import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './styles.css';

import { isEmailValid } from '../../../utils';
import { SendResetMail } from '../../ScreenElements/SendResetMail';
import { ChangePassword } from '../../ScreenElements/ChangePassword';

import { sendResetPassword } from '../../../Actions/users';
import {clientMedia} from "../../../Config/Settings";

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            isSubmitted: false
        }
    }

    renderBox() {
        if (this.props.location.pathname === '/forgot-password') {
            return (
                <SendResetMail
                    onChangeMail={this.onMailChange.bind(this)}
                    onSubmit={this.onSubmit.bind(this)}
                    isSubmitted={this.state.isSubmitted}
                />
            )
        }

        if (this.props.location.pathname.includes('/change-password')) {
            return (
                <ChangePassword token={this.props.params.token} />
            )
        }
    }

    onMailChange(email) {
        this.setState({ email });
    }

    onSubmit() {
        if (!isEmailValid(this.state.email)) {
            alert('משהו לא תקין במייל');

            return;
        }

        this.setState({ isSubmitted: true });

        this.props.sendResetPassword(this.state.email);
    }

    render() {
        return (
            <div className="forgot-password-wrapper">
                {this.renderBox()}
                <div className="fireworks-wrapper">
                    <img className="yellow" src={`${clientMedia()}/img/logos/large-yellow-firework.png`} alt="yello-firework"/>
                    <img className="green" src={`${clientMedia()}/img/logos/large-green-firework.png`} alt="green-firework"/>
                    <img className="green-small" src={`${clientMedia()}/img/logos/small-firework.png`} alt="small-firework"/>
                </div>
            </div>
        )
    }
}

ForgotPassword.propTypes = {
    sendResetPassword: PropTypes.func,
    location: PropTypes.object,
    params: PropTypes.object
};

export default connect(null, {sendResetPassword})(ForgotPassword);



// WEBPACK FOOTER //
// ./src/Components/Screens/ForgotPassword/ForgotPassword.js